import BaseRepository from '@/repository/BaseRepository'

export default class MetaRepository extends BaseRepository {
  async getMeta() {
    return this.get('/meta')
  }
}